module.exports = __webpack_public_path__ + "static/media/blackalo50.09143694.png";